import FullInfoField from 'components/FullInfoField/FullInfoField';
import React, { useContext } from 'react';
import {
	IRestaurantFullInfoContext,
	RestaurantFullInfoContext,
} from '../../../../../../../restaurantFullInfoState/restaurantFullInfoContext';
import moment from 'moment';

const CreatedField: React.FC = () => {
	const { restaurantForFullInfo } = useContext<IRestaurantFullInfoContext>(RestaurantFullInfoContext);

	const inputValue = restaurantForFullInfo?.insertedDate
		? `${moment(restaurantForFullInfo.insertedDate).format('MM/DD/YYYY h:mm:ss A')} ${
				restaurantForFullInfo.insertedBy
		  }`
		: undefined;

	return <FullInfoField label="createdLabel" value={inputValue} />;
};

export default CreatedField;
